module.exports = __webpack_public_path__ + "static/media/baby-sitter.10d376bb.jpg";